import { Skeleton } from '@mui/material';
import { useParams } from 'react-router-dom';
import { CerebroPageContainer } from '../../shared/components';
import { useDataRoomQuery } from '../../shared/hooks';
import { DirectConnectMilestonePage } from './DirectConnectMilestonePage';
import { MilestonePage } from './MilestonePage';

export const Milestones: React.FC = () => {
	const { guid } = useParams<'guid'>();
	const dataRoomQuery = useDataRoomQuery(guid);

	if (!dataRoomQuery.isSuccess) {
		return (
			<CerebroPageContainer maxWidth="100%">
				<Skeleton height={60} />
				<Skeleton height={60} />
				<Skeleton height={60} />
			</CerebroPageContainer>
		);
	}

	if (dataRoomQuery.data.isDirectIntroDeal) {
		return <DirectConnectMilestonePage dataRoom={dataRoomQuery.data} />;
	}

	return <MilestonePage dataRoom={dataRoomQuery.data} />;
};
